import {
  Button,
  Card,
  Container,
  FormControl,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const useStyle = makeStyles(() => ({
  titleCard: {
    marginTop: "20px",
    padding: "10px",
    background: "#F2F2F2",
  },
  formControlStyle: {
    display: "flex",
    alignItems: "center",
    justifyItems: "flex-start",
    width: "100%",
    margin: "10px 0px",
    flexDirection: "row",
    background: "none",
  },
}));

export default function UserManagementDetail() {
  // Route
  const navigate = useNavigate();
  const { id } = useParams();

  // Material UI
  const styles = useStyle();

  // Redux State
  const user = useSelector((state) => state.userManagement.data);

  // Local State
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    roleId: "",
    roleName: "",
    sourceType: "",
    employeeId: "",
    employeeName: "",
    farmerId: "",
    farmerName: "",
  });
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      let x = user.docs.findIndex((item) => item._id === id);
      if (x !== -1) {
        setFormData({
          username: user.docs[x].username ? user.docs[x].username : "",
          password: user.docs[x].password ? user.docs[x].password : "",
          roleId: user.docs[x].roleId ? user.docs[x].roleId : "",
          roleName: user.docs[x].roleId ? user.docs[x].roleId.roleName : "",
          sourceType: user.docs[x].source ? user.docs[x].source.sourceType : "",
          employeeId: user.docs[x].source?.employeeId
            ? user.docs[x].source.employeeId._id
            : "",
          employeeName: user.docs[x].source?.employeeId
            ? user.docs[x].source.employeeId.fullName
            : "",
          farmerId: user.docs[x].source?.farmerId
            ? user.docs[x].source.farmerId._id
            : "",
          farmerName: user.docs[x].source?.farmerId
            ? user.docs[x].source.farmerId?.fullName
            : "",
        });
      }
      setFetch(false);
    }
  }, [fetch]);

  return (
    <Container>
      <Card className={styles.titleCard}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          Detail User
        </Typography>
      </Card>
      <Card className={styles.titleCard}>
        <form>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              Username
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 15,
                readOnly: true,
                style: { background: "white" },
              }}
              required
              size="small"
              name="username"
              value={formData.username}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              ROLE
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              select
              required
              size="small"
              error={false}
              name="roleId"
              value={formData.roleId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.roleId ? (
                <MenuItem value={formData.roleId}>{formData.roleName}</MenuItem>
              ) : (
                ""
              )}
            </TextField>
          </FormControl>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              Karyawan
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              select
              required
              size="small"
              error={false}
              name="sourceType"
              value={formData.sourceType}
              variant="outlined"
              style={{
                maxWidth: "400px",
                minWidth: "140px",
                background: "white",
                marginRight: "10px",
              }}
            >
              <MenuItem value="employee">Karyawan</MenuItem>
              <MenuItem value="farmer">Petani</MenuItem>
            </TextField>
            {formData.sourceType === "employee" ? (
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ readOnly: true }}
                select
                required
                size="small"
                error={false}
                name="employeeId"
                value={formData.employeeId}
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  width: "250px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.employeeName && formData.employeeId.length > 0 ? (
                  <MenuItem value={formData.employeeId}>
                    {formData.employeeName}
                  </MenuItem>
                ) : (
                  ""
                )}
              </TextField>
            ) : (
              ""
            )}
            {formData.sourceType === "farmer" ? (
              <TextField
                InputLabelProps={{ shrink: true }}
                inputProps={{ readOnly: true }}
                select
                required
                size="small"
                error={false}
                name="farmerId"
                value={formData.farmerId}
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    style: {
                      height: "300px",
                    },
                  },
                }}
                style={{
                  maxWidth: "400px",
                  width: "250px",
                  background: "white",
                  marginRight: "10px",
                }}
              >
                {formData.farmerName && formData.farmerId.length > 0 ? (
                  <MenuItem value={formData.farmerId}>
                    {formData.farmerName}
                  </MenuItem>
                ) : (
                  ""
                )}
              </TextField>
            ) : (
              ""
            )}
          </FormControl>

          <div>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: 5 }}
              onClick={() => navigate("/admin/user-management")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Container>
  );
}
